<template>
  <div>
    <Card shadow>
      <Row style="display: none">
        <Col style="display:none">
          <!-- {{plat_list}} -->
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platform"
              filterable
              placeholder="选择APP分组"
              clearable
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="选择APP盘口"
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid || 0"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col flex="auto">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">智能风控标签:</span>
            <Select
              v-model="table.params.smart_tag"
              filterable
              placeholder="筛选智能风控标签"
              clearable
            >
              <Option
                v-for="(item, index) in select.tag_iist.filter(
                  item => item.tag_type == 'smart_tag'
                )"
                :value="item.id"
                :label="item.tag_name"
                :key="index"
              >
                {{ item.tag_name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col flex="auto">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">游戏风控标签:</span>
            <Select
              v-model="table.params.risk_tag"
              filterable
              placeholder="筛选游戏风控标签"
              clearable
            >
              <Option
                v-for="(item, index) in select.tag_iist.filter(
                  item => item.tag_type == 'risk_tag'
                )"
                :value="item.id"
                :label="item.tag_name"
                :key="index"
              >
                {{ item.tag_name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col style="display: flex; justify-content: space-between">
          <Button
            type="primary"
            @click="GetTagSettingList"
            style="marginRight: 10px"
            >查询</Button
          >
          <Button type="primary" @click="syncConfig">同步配置</Button>
        </Col>
      </Row>
      <div style="display: flex; flex-wrap: wrap; ">
        <label style="display: flex; align-items: center; margin: 5px">
          <span style="width: 40px">代理:</span>
          <Select
            v-model="table.params.app_id"
            filterable
            placeholder="选择APP盘口"
            clearable
            style="width: 150px"
          >
            <Option
              v-for="(item, index) in app_list"
              :value="item.appid || 0"
              :label="item.appName"
              :key="index"
            >
              {{ item.appName }}
              <span style="color: #bbb">({{ item.appid }})</span>
            </Option>
          </Select>
        </label>
        <label style="display: flex; align-items: center; margin: 5px">
          <span style="width: 100px">智能风控标签:</span>
          <Select
            v-model="table.params.smart_tag"
            filterable
            placeholder="筛选智能风控标签"
            clearable
            style="width: 230px;"
          >
            <Option
              v-for="(item, index) in select.tag_iist.filter(
                item => item.tag_type == 'smart_tag'
              )"
              :value="item.id"
              :label="item.tag_name"
              :key="index"
              style="width: 220px"
            >
              <span
                style="display: inline-block; width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                {{ item.tag_name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </span>
            </Option>
          </Select>
        </label>
        <label style="display: flex; align-items: center; margin: 5px">
          <span style="width: 100px">游戏风控标签:</span>
          <Select
            v-model="table.params.risk_tag"
            filterable
            placeholder="筛选游戏风控标签"
            clearable
            style="width: 230px;"
          >
            <Option
              v-for="(item, index) in select.tag_iist.filter(
                item => item.tag_type == 'risk_tag'
              )"
              :value="item.id"
              :label="item.tag_name"
              :key="index"
              style="width: 220px"
            >
              <span
                style="display: inline-block; width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                {{ item.tag_name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </span>
            </Option>
          </Select>
        </label>
        <span style="display: flex; align-items: center;">
          <Button type="primary" @click="GetTagSettingList" style="margin: 10px"
            >查询</Button
          >
          <Button type="primary" @click="syncConfig">同步配置</Button>
        </span>
      </div>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
    ></Table>

    <!-- 更新APP风控配置 -->
    <Modal v-model="setModal.show" @on-cancel="ClosesetModal" width="600">
      <div slot="header">编辑风控配置</div>
      <Form
        :ref="setModal.ref"
        :model="setModal.params"
        :rules="setModal.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="智能风控标签">
              <Select
                v-model="setModal.params.smart_tag"
                filterable
                placeholder="筛选智能风控标签"
                clearable
                multiple
              >
                <Option
                  v-for="item in select.tag_iist.filter(
                    item => item.tag_type == 'smart_tag'
                  )"
                  :value="item.id"
                  :label="item.tag_name"
                  :key="item.id"
                >
                  {{ item.tag_name }}
                  <span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="游戏风控标签">
              <Select
                v-model="setModal.params.risk_tag"
                filterable
                placeholder="筛选游戏风控标签"
                multiple
                clearable
              >
                <Option
                  v-for="item in select.tag_iist.filter(
                    item => item.tag_type == 'risk_tag'
                  )"
                  :value="item.id"
                  :label="item.tag_name"
                  :key="item.id"
                >
                  {{ item.tag_name }}
                  <span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateTagSetting">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetAppTagList,
  GetTagSetting,
  UpdateTagSetting,
  RefreshConfig
} from '@/api/admin/risk'
export default {
  name: 'riskAppConf',
  data() {
    return {
      select: { tag_iist: [] },
      table: {
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            title: '所属分组',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let app_info = this.getAppInfo(params.row)
              return h('div', [
                h('span', app_info.name || ''),
                h('span', { style: 'color:#bbb;' }, ` (${app_info.id || ''})`)
              ])
            }
          },
          {
            title: '盘口信息',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) =>
              h('div', [
                h('span', params.row.app_name),
                h('span', { style: 'color:#bbb;' }, ` (${params.row.app_id})`)
              ])
          },
          {
            title: '智能风控标签',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let arr = []
              params.row.smart_tag.map(item => {
                let app_tag =
                  this.select.tag_iist.find(item1 => item1['id'] == item) || {}
                arr.push(
                  h('p', [
                    h('span', app_tag.tag_name || ''),
                    h(
                      'span',
                      { style: 'color:#bbb;' },
                      ` (${app_tag.id || ''})`
                    )
                  ])
                )
              })
              return h('div', arr)
            }
          },
          {
            title: '游戏风控标签',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let arr = []
              params.row.risk_tag.map(item => {
                let app_tag =
                  this.select.tag_iist.find(item1 => item1.id == item) || {}
                arr.push(
                  h('p', [
                    h('span', app_tag.tag_name || ''),
                    h(
                      'span',
                      { style: 'color:#bbb;' },
                      ` (${app_tag.id || ''})`
                    )
                  ])
                )
              })
              return h('div', arr)
            }
          },
          {
            fixed: 'right',
            title: '操作',
            align: 'center',
            width: 160,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.OpensetModal(params.row)
                      }
                    }
                  },
                  '编辑'
                )
              ])
            }
          }
        ],
        data: [],
        params: { platform: 0, app_id: -1, risk_tag: 0, smart_tag: 0 }
      },
      setModal: {
        show: false,
        params: { platform: 0, app_id: 0, risk_tag: [], smart_tag: [] },
        rules: {
          risk_tag: [
            {
              required: true,
              trigger: 'change',
              validator: this.simpleVerify(new Error('请选择游戏风控标签'))
            }
          ],
          smart_tag: [
            {
              required: true,
              trigger: 'change',
              validator: this.simpleVerify(new Error('请选择智能风控标签'))
            }
          ]
        },
        ref: 'setTag'
      }
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/riskManager/riskAppConf') {
          this.GetAppTagListList()
        }
      },
      immediate: true
    }
  },
  methods: {
    GetAppTagListList() {
      GetAppTagList({ tag_type: 0, page_size: 1000 }).then(res => {
        this.select.tag_iist = res._param.List || []
      })
    },

    //获取配置列表
    GetTagSettingList() {
      let params = {
        ...this.table.params,
        app_id:
          this.table.params.app_id == undefined ? -1 : this.table.params.app_id
      }

      GetTagSetting(params).then(res => {
        this.table.data = res._param.data || []
      })
    },

    // 编辑和新增
    OpensetModal(row = {}) {
      let data = { ...row }
      delete data._index
      delete data._rowKey
      delete data.app_name
      this.setModal.params = data
      this.setModal.show = true
    },
    //关闭编辑配置
    ClosesetModal() {
      this.$refs[this.setModal.ref].resetFields()
      this.setModal.show = false
    },
    //同步配置
    syncConfig() {
      let param = {
        plat_ids: this.plat_list.reduce((res, cur) => {
          res.push(cur.id)
          return res
        }, []),
        refresh_cfg: [1, 2, 3]
      }
      RefreshConfig(param).then(() => {
        this.$Notice.success({
          desc: '同步成功！'
        })
      })
    },
    //提交编辑
    updateTagSetting() {
      let params = { ...this.setModal.params }
      UpdateTagSetting(params).then(() => {
        this.ClosesetModal()
        this.GetTagSettingList()
      })
    },
    getAppInfo(el) {
      return this.plat_list.find(item => item.id == el.platform) || {}
    }
  },
  created() {
    // this.GetAppTagListList()
    this.GetTagSettingList()
  }
}
</script>
<style lang="less" scoped></style>
